module.exports = "<head>\r\n    \r\n</head>\r\n\r\n<body class=\"page-header-fixed page-sidebar-closed-hide-logo page-container-bg-solid page-content-white\">\r\n    <header></header>\r\n    <div class=\"page-container\">\r\n        <loading backgroundColor=\"{{backLoad}}\" *ngIf=\"showLoad\"></loading>\r\n        <leftmenu></leftmenu>\r\n\r\n        <router-outlet *ngIf=\"loaded\"></router-outlet>\r\n        <!-- <dashboard></dashboard> -->\r\n    </div>\r\n</body>"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/admin.component.html
// module id = ./src/app/admin/admin.component.html
// module chunks = main